// extracted by mini-css-extract-plugin
module.exports = {"createPost":"styles_createPost__2bDcu"};